export const SMART_TOPIC_HEADING_TYPE = 'header-3';
